import React, { useContext, useEffect, useState } from 'react';

const PrivacyPolicy = () => {
    return (
        <div id="login-privacy-policy-link" style={{fontSize: "16px"}}>
            By proceeding, you agree to Aditya Birla Capital Limited's&nbsp;&nbsp;
            <a
                href="https://finance.adityabirlacapital.com/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                style={{backgroundColor: "none", color:"#0074CC", textDecoration:"underline"}}
            >
                privacy policy
            </a>
            &nbsp;and&nbsp; 
            <a
                href="https://finance.adityabirlacapital.com/terms-and-conditions"
                target="_blank"
                rel="noopener noreferrer"
                style={{backgroundColor: "none", color:"#0074CC", textDecoration:"underline"}}
            >
                terms and conditions
            </a>
        </div>
    );
};

export default PrivacyPolicy;